<template>
  <Modal
    :modal="modal"
    title="Selecione o Cliente"
    cardBodyClass="pa-0"
    @close="$emit('close')"
    @save="save"
    @insert="createCliente"
    @refresh="getClientesAPI"
    @search="searchBox = !searchBox"
    :loading="loading"
    :fullscreen="true"
    :titleIcons="titleIcons"
  >
    <ListClientesSelect
      :searchBox="searchBox"
      @clienteSelected="clienteSelected = $event"
    />
  </Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Modal from '@/components/shared/Modal';
import ListClientesSelect from '@/components/clientes/ListClientesSelect';

export default {
  name: 'ModalCliente',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
  },
  components: {
    Modal,
    ListClientesSelect,
  },
  data() {
    return {
      page: 1,
      order: 'fantasia',
      loading: false,
      searchBox: false,
      clienteSelected: null,
    }
  },
  computed: {
    ...mapGetters(['clientes']),
    titleIcons() {
      return [
        { name: 'mdi-plus', event: 'insert', loading: false },
        { name: 'mdi-refresh', event: 'refresh', loading: true },
        { name: this.searchBox ? 'mdi-close' : 'mdi-magnify', event: 'search', loading: false },
      ]
    }
  },
  methods: {
    ...mapMutations(['SHOW_SNACKBAR']),
    ...mapActions(['fetchClientes', 'fetchClientesAPI', 'createCliente']),
    getClientes() {
      this.loading = true;
        this.fetchClientes()
          .then(() => this.loading = false);
    },
    getClientesAPI() {
      this.loading = true;
        this.fetchClientesAPI()
          .then(() => this.loading = false);
    },
    save() {
      if (this.clienteSelected) {
        this.$emit('save', this.clienteSelected);
      } else {
        this.SHOW_SNACKBAR({ text: 'Selecione o cliente!', status: 'error' });
      }
    }
  },
  watch: {
    modal(value) {
      if (value && !this.clientes.length && !this.loading) {
        this.getClientes();
      }
    },
  },
}
</script>

<style>

</style>